import React, { useContext, useState } from 'react';
import { PriceCalculationContext } from '../PriceCalculationContext';
import { getOrganizationsByAvailability } from '../../Login/utils/getOrganizationsByAvailability';

export function SchoolSelection() {
    const [checkedOrganizations, setCheckedOrganizations] = useState({});
    const [allSchoolsAreSelected, setAllSchoolsAreSelected] = useState(false);

    const {
        resourcedTexts,
        organizationData,
        productData,
        handleSchoolSelectionSubmit,
        fixedAmountIsLoadingText,
    } = useContext(PriceCalculationContext);

    const { availableOrganizations, unavailableOrganizations } = getOrganizationsByAvailability(
        organizationData,
        productData,
    );

    function handleCheckOrganization({ id }) {
        const newCheckedOrganizations = { ...checkedOrganizations };

        const isAlreadyChecked = Boolean(checkedOrganizations[id]);
        if (isAlreadyChecked) {
            delete newCheckedOrganizations[id];
        } else {
            newCheckedOrganizations[id] = true;
        }

        setCheckedOrganizations(newCheckedOrganizations);

        const allAreSelected = availableOrganizations.every(({ id }) => newCheckedOrganizations[id] === true);
        setAllSchoolsAreSelected(allAreSelected);
    }

    function handleSelectOrDeselectAll() {
        const selectAll = !allSchoolsAreSelected;
        if (selectAll) {
            const newCheckedOrganizations = {};
            availableOrganizations.forEach(({ id }) => {
                newCheckedOrganizations[id] = true;
            });
            setCheckedOrganizations(newCheckedOrganizations);
            setAllSchoolsAreSelected(true);
            return;
        }

        setCheckedOrganizations({});
        setAllSchoolsAreSelected(false);
    }

    const schoolSelectionIsLoading = Boolean(fixedAmountIsLoadingText);
    const showSelectDeselectCheckbox = availableOrganizations.length > 1;

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSchoolSelectionSubmit(checkedOrganizations);
            }}
            noValidate
        >
            <div className="school-selection">
                <div className="form-field">
                    {showSelectDeselectCheckbox && (
                        <>
                            <span className="ktc-checkbox">
                                <input
                                    type="checkbox"
                                    className="form-control"
                                    name="selectOrDeselectAllSchools"
                                    id="selectOrDeselectAllSchools"
                                    value="selectOrDeselectAllSchools"
                                    onChange={handleSelectOrDeselectAll}
                                    checked={allSchoolsAreSelected}
                                />
                                <label htmlFor="selectOrDeselectAllSchools">
                                    <strong>{resourcedTexts.selectDeselectAllSchools}</strong>
                                </label>
                            </span>

                            <hr />
                        </>
                    )}

                    {availableOrganizations.map((org) => (
                        <span className="ktc-checkbox" key={org.id}>
                            <input
                                type="checkbox"
                                className="form-control"
                                name="organization"
                                id={org.id}
                                value={org.id}
                                onChange={() => handleCheckOrganization(org)}
                                checked={Boolean(checkedOrganizations[org.id])}
                            />
                            <label htmlFor={org.id}>{org.name}</label>
                        </span>
                    ))}
                </div>

                <button
                    className="school-selection__button button primary"
                    disabled={Object.keys(checkedOrganizations).length === 0 || schoolSelectionIsLoading}
                >
                    {schoolSelectionIsLoading
                        ? resourcedTexts.loadingButton
                        : resourcedTexts.selectSchoolButton}
                </button>

                {unavailableOrganizations.length > 0 && (
                    <>
                        <hr className="school-selection__unavailable-hr" />

                        <p className="school-selection__unavailable-remark">
                            {resourcedTexts.organizationsUnavailableRemark}
                        </p>

                        <div className="form-field">
                            {unavailableOrganizations.map(({ id, name }) => (
                                <span className="ktc-checkbox" key={id}>
                                    <input
                                        type="checkbox"
                                        className="form-control"
                                        name="unavailableOrganization"
                                        id={id}
                                        disabled
                                    />
                                    <label htmlFor={id}>{name}</label>
                                </span>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </form>
    );
}
